import React from 'react';
import Navbar from './components/layout/Navbar';
import Hero from './components/sections/Hero';
import FounderMirror from './components/sections/FounderMirror';
import WhatWeDo from './components/sections/WhatWeDo';
import Framework from './components/sections/Framework';
import Diagnostic from './components/sections/Diagnostic';
import About from './components/sections/About';
import Offers from './components/sections/Offers';
import ClaritySession from './components/sections/ClaritySession';
import FinalCTA from './components/sections/FinalCTA';
import Footer from './components/layout/Footer';

function App() {
  return (
    <div className="min-h-screen bg-brand-cream font-sans text-brand-deep">
      <Navbar />
      <main>
        <Hero />
        <FounderMirror />
        <WhatWeDo />
        <Framework />
        <Diagnostic />
        <About />
        <Offers />
        <ClaritySession />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;